import * as React from 'react'
import type { SVGProps } from 'react'
const SvgBolt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    fill='#e3e3e3'
    viewBox='0 -960 960 960'
    {...props}
  >
    <path d='M360-360H236q-24 0-35.5-21.5T203-423l299-430q10-14 26-19.5t33 .5q17 6 25 21t6 32l-32 259h155q26 0 36.5 23t-6.5 43L416-100q-11 13-27 17t-31-3q-15-7-23.5-21.5T328-139z' />
  </svg>
)
export default SvgBolt
